import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import {
  changePurposeRecognition,
  fetchGrantPurposeConfig,
  cancelGrantFlow,
} from "../../actions";
import GrantPurpose from "../GrantPurpose/GrantPurpose";
import GrantRecognition from "../GrantRecognition/GrantRecognition";
import PermissionToPublish from "../PermissionToPublish/PermissionToPublish";
import {
  SectionMediumDivider,
} from "../../style";
import FlowFooter from "../FlowFooter/FlowFooter";
import PreviewLetter from "../ViewEditSchedules/Components/PreviewLetter";
import { fetchAccountAdvisors } from "../../../../../../actions/globalActions";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { isGeminiUser } from "../../../../../../utils/sessionUtil";
import { moveIntoErrorPosition } from "../../../../../../utils/commonUtil";

import { purposeRecognitionDerivedStates } from '../../Selectors/PurposeRecognitionSelectors';


export class PurposeRecognition extends Component {
  state = {
    data: {
      purposeId: "",
      purposeName: "",
      additionalComments: "",
      missionaryName: "",
      eventName: "",
      projectName: "",
      missionaryLocation: "",
      purposeCertification: false,
      standardLanguage: "",
      grantRecognition: "10",
      notifyFirstName: "",
      notifyLastName: "",
      inMemoryOfName: "",
      inHonorOfName: "",
      thirdParty: "",
      accountName: "",
      includeAdvisorInfo: true,
      publishName: (typeof this.props.permissionToPublish === "boolean") ? this.props.permissionToPublish : true,
    },
    purposeFormValid: false,
    recognitionFormValid: false,
    individualValidator: false,
  };


  componentDidMount() {
    window.scrollTo(0, 0)
    const { accountId } = this.props;
    this.props.fetchGrantPurposeConfig({
      method: "GET",
      url: `/donor-portal/api/grant/${accountId}/getAllGrantPurposes`,
      page: "recommendGrant"
    });
    this.props.fetchAdvisors({ accountId });
    window.scrollTo(0, 0);
  }

  isEnabled = () => this.state.purposeFormValid && this.state.recognitionFormValid;

  // Check the feature is avalilable by the particular csr user
  checkCsrBusiness = businessFunction => {
    return checkCSRBusinessFunction(BUSINESS_FUNCTION[businessFunction], this.props.csrBusinessFunction);
  }

  /** Checks for any field change in the entire component */
  formEqual = () => {
    const { purposeId,
      additionalComments,
      missionaryName,
      eventName,
      projectName,
      missionaryLocation,
      purposeCertification,
      grantRecognition,
      notifyFirstName,
      notifyLastName,
      inMemoryOfName,
      inHonorOfName,
      thirdParty,
      includeAdvisorInfo,
      publishName,
    } = this.state.data;

    const stateData = {
      purposeId,
      additionalComments,
      missionaryName,
      eventName,
      projectName,
      missionaryLocation,
      purposeCertification,
      grantRecognition,
      notifyFirstName,
      notifyLastName,
      inMemoryOfName,
      inHonorOfName,
      thirdParty,
      includeAdvisorInfo,
      publishName,
    };
    const propsData = {
      purposeId: this.props.grantPurposeId ? this.props.grantPurposeId : '',
      additionalComments: this.props.purposeComments ? this.props.purposeComments : '',
      missionaryName: this.props.missionaryName ? this.props.missionaryName : '',
      eventName: this.props.eventName ? this.props.eventName : '',
      projectName: this.props.projectName ? this.props.projectName : '',
      missionaryLocation: this.props.missionaryLocation ? this.props.missionaryLocation : '',
      purposeCertification: this.props.purposeCertification,
      grantRecognition: this.props.recognitionId ? this.props.recognitionId : '',
      notifyFirstName: this.props.notifyFirstName ? this.props.notifyFirstName : '',
      notifyLastName: this.props.notifyLastName ? this.props.notifyLastName : '',
      inMemoryOfName: this.props.memoryOf ? this.props.memoryOf : '',
      inHonorOfName: this.props.honorOf ? this.props.honorOf : '',
      thirdParty: this.props.advisorThirdPartyComment ? this.props.advisorThirdPartyComment : '',
      includeAdvisorInfo: this.props.includeAdvisorInfo ? this.props.includeAdvisorInfo : false,
      publishName: this.props.permissionToPublish,
    };

    return isEqual(stateData, propsData);
  }

  isUpdateEnabled = () => {
    let csrBusiness = (isGeminiUser() && this.props.applicable_business_function && this.props.applicable_business_function.length > 0 ? !this.checkCsrBusiness(this.props.applicable_business_function[0]) : true)
    return !this.formEqual() && this.state.purposeFormValid && this.state.recognitionFormValid ? 
      csrBusiness : !this.formEqual() && this.state.purposeFormValid && this.state.recognitionFormValid
  }

  isUpdateEnabledInCsr = () => {
    return (isGeminiUser() && this.props.applicable_business_function && this.props.applicable_business_function.length > 0 ? !this.checkCsrBusiness(this.props.applicable_business_function[0]) : true)
  }

  submitData = () => {
    const { data } = this.state;
    this.props.changePurposeRecognition({
      ...data
    });
  };

  handleSubmit = () => {
    const { history } = this.props;
    this.setState({ individualValidator: !this.state.individualValidator });

    if (this.isEnabled()) {
      this.submitData();
      history.push('/grants/recommend/allocation-schedule');
    }
    else {
      setTimeout(()=> {
        moveIntoErrorPosition(".error-fields")
      },0);
    }
  };

  handleUpdate = () => {
    const { analyticsHandler, stepDesc, onUpdate, history } = this.props;
    this.setState({ individualValidator: !this.state.individualValidator });

    if(this.isUpdateEnabled()) {
      this.submitData();
      analyticsHandler && 
      analyticsHandler(
        `${stepDesc ? 'update' : 'update2'}`,
         `${stepDesc ? `Step 1 ${stepDesc}` : ''}`,
         `Update ${stepDesc ? '' :this.props.scheduleType === 'recurring' ? " - Recurring Grant" : " - One Time Grant"}`);
      onUpdate();
    }
    else {
      if(this.formEqual()) {
        if(stepDesc) history.push('/grants/recommend/review');
        else history.goBack(); 
      }
      else {
        setTimeout(()=> {
          moveIntoErrorPosition(".error-fields")
        },0);
      }
    }
  }

  handleExit = () => {
    const { analyticsHandler, history, stepDesc, cancelGrantFlow } = this.props;
    (analyticsHandler && stepDesc) && analyticsHandler('exit', `Step 1 ${stepDesc}`, 'Exit');
    cancelGrantFlow();
    history.push('/');
  };

  handleBack = () => {
    const { analyticsHandler, history, stepDesc } = this.props;
    (analyticsHandler && stepDesc) && analyticsHandler('back', `Step 1 ${stepDesc}`, 'Back');
    history.push('/grants/recommend');
  };

  handlePurposeChange = ({ data, isFormValid }) => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        purposeId: "",
        purposeName: "",
        additionalComments: "",
        eventName: "",
        missionaryName: "",
        missionaryLocation: "",
        projectName: "",
        purposeCertification: false,
        standardLanguage: "",
        ...data
      },
      purposeFormValid: isFormValid,
    }));
  }

  handleRecognitionChange = ({ data, isFormValid }) => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        grantRecognition: "10",
        notifyFirstName: "",
        notifyLastName: "",
        inMemoryOfName: "",
        inHonorOfName: "",
        thirdParty: "",
        accountName: "",
        includeAdvisorInfo: true,
        publishName: data.grantRecognition === "30" ? false : prevState.data.publishName,
        ...data
      },
      recognitionFormValid: isFormValid,
    }));
  }

  // Not checking form validity as it is optional
  handlePermissionChange = ({ data }) => {
    this.setState(prevState => ({
      data: { ...prevState.data, ...data },
    }));
  }

  render() {
    const {
      page,
      grantPurposeData,
      grantPurposeLoading,
      recognitionId,
      honorOf,
      memoryOf,
      notifyFirstName,
      notifyLastName,
      advisorThirdPartyComment,
      grantPurposeId,
      purposeComments,
      projectName,
      eventName,
      missionaryName,
      missionaryLocation,
      purposeCertification,
      grantPurposeName,
      editMode,
      enableCancelPopUp, // passed from parent
      includeAdvisorInfo,
      keyPropertyUpdate
    } = this.props;

    const { individualValidator } = this.state;
    return (
      <div>
        <GrantPurpose
          isLoading={grantPurposeLoading}
          grantPurposeData={grantPurposeData}
          handleFormChange={this.handlePurposeChange}
          grantPurposeId={grantPurposeId}
          addtnlComments={purposeComments}
          eventName={eventName}
          projectName={projectName}
          missionaryName={missionaryName}
          missionaryLocation={missionaryLocation}
          purposeCertification={purposeCertification}
          selectedPurposeName={grantPurposeName}
          individualValidator={individualValidator}
        />
        <SectionMediumDivider />
        <GrantRecognition
          includeAdvisorInfo={!includeAdvisorInfo}
          recognitionOption={recognitionId}
          honorOf={honorOf}
          memoryOf={memoryOf}
          firstName={notifyFirstName}
          lastName={notifyLastName}
          comments={advisorThirdPartyComment}
          handleFormChange={this.handleRecognitionChange}
          individualValidator={individualValidator}
        />

        {this.state.data.grantRecognition && this.state.data.grantRecognition !== "30" && (
          <div>
            <SectionMediumDivider />
            <PermissionToPublish handleFormChange={this.handlePermissionChange} publishCheck={!this.state.data.publishName}  page={"Recommend a Grant"} />
          </div>
        )}

        <SectionMediumDivider smallMarginBottom />
        <PreviewLetter noBorderTop noPadding noBorderBottom
          stepNum={1}
          stepDesc={this.props.stepDesc}
          analyticsHandler={this.props.analyticsHandler}
          charityName={this.props.charityName}
          charityAddress={this.props.charityAddress}
          startDate={this.props.startDate}
          grantAmount={this.props.grantAmount}
          purposeName={this.state.data.purposeName}
          additionalComments={this.state.data.additionalComments}
          notifyFirstName={this.state.data.notifyFirstName}
          notifyLastName={this.state.data.notifyLastName}
          inMemoryOfName={this.state.data.inMemoryOfName}
          inHonorOfName={this.state.data.inHonorOfName}
          thirdParty={this.state.data.thirdParty}
          includeAdvisorInfo={this.state.data.includeAdvisorInfo}
          grantRecognition={this.state.data.grantRecognition}
          publishName={this.state.data.publishName}
          advisors={this.props.advisors}
          codeValueMappingData={this.props.codeValueMappingData}
          projectName={this.props.projectName}
        />
        <SectionMediumDivider smallMarginTop />
        <FlowFooter
          page={page}
          keyProperty={page === "Edit Grant" ? "Cancel Edit Grant" : "Cancel Recommend a Grant"}
          keyPropertyUpdate={keyPropertyUpdate}
          enableCancelPopUp={enableCancelPopUp && this.isUpdateEnabled()}
          enableUpdate={this.isUpdateEnabledInCsr()}
          handlePrimaryCta={this.handleSubmit}
          handleSecondaryCta={this.handleBack}
          handleExitCta={this.handleExit}
          handleUpdateCta={this.handleUpdate}
          handleUpdateCancel={() => this.props.onUpdateCancel(this.props.stepDesc, 1, this.props.scheduleType)}
          edit={editMode}
          exitPopupTitle="Cancel grant recommendation"
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  fetchGrantPurposeConfig: payload => dispatch(fetchGrantPurposeConfig(payload)),
  changePurposeRecognition: payload => dispatch(changePurposeRecognition(payload)),
  cancelGrantFlow: payload => dispatch(cancelGrantFlow(payload)),
  fetchAdvisors: payload => dispatch(fetchAccountAdvisors(payload)),
});

const mapStateToProps = state => ({
  ...purposeRecognitionDerivedStates(state.toJS()),
});

PurposeRecognition.propTypes = {
  accountId: PropTypes.string,
  allocationType: PropTypes.string,
  analyticsHandler: PropTypes.func,
  availableBalance: PropTypes.number,
  charityBackPath: PropTypes.string,
  currentBalance: PropTypes.number,
  editMode: PropTypes.bool,
  enableCancelPopUp: PropTypes.bool,
  getAvailableBalance: PropTypes.func,
  grantAmount: PropTypes.string,
  grantPurposeName: PropTypes.string,
  grantRecognitionId: PropTypes.string,
  history: PropTypes.object,
  keyPropertyUpdate: PropTypes.string,
  location: PropTypes.object,
  newGrant: PropTypes.func,
  noOfPayments: PropTypes.number,
  onUpdate: PropTypes.func,
  onUpdateCancel: PropTypes.func,
  page: PropTypes.string,
  scheduleType: PropTypes.string,
  selectedAccountId: PropTypes.string,
  selectedAllShares: PropTypes.bool,
  selectedAllSharesAllPools: PropTypes.bool,
  selectedCharityEin: PropTypes.string,
  selectedCharityName: PropTypes.string,
  setUserSession: PropTypes.func,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  stepDesc: PropTypes.string,
  userSelectedDateVal: PropTypes.string,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PurposeRecognition)
);
